import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const whatIsNewSlice = createSlice({
  name: "whatIsNew",
  initialState,
  reducers: {
    whatIsNewLoading(state) {
      state.loading = true;
      state.error = null;
    },
    whatIsNewError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setWhatIsNewList(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { whatIsNewLoading, whatIsNewError, setWhatIsNewList } =
  whatIsNewSlice.actions;

export default whatIsNewSlice.reducer;
